<template>
  <div class="advertisement">
    <div class="advertisement_top">
      <div class="top_titleArea">
        <h3 class="title">广告</h3>
        <ul class="titleArea_option">
          <li class="option_item">标准</li>
          <li class="option_item active">以商品创建广告</li>
        </ul>
      </div>
      <div class="top_ifon">
        <div class="ifon_left">
          <span class="text">已创建1个广告</span>
        </div>
        <div class="ifon_right">
          <button class="right_button">
            <i class="el-icon-circle-plus-outline" />
            添加一个广告
          </button>
        </div>
      </div>
    </div>
    <div class="advertisement_main">
      <StandardCreation
        :current-ifon="currentIfon"
        :radioone="radioone"
        :radiotwo="radiotwo"
        :campaign="campaign"
        :strategy_opt="strategy_opt"
        :bid_strategy="bid_strategy"
        :ad_target="ad_target"
        :budget="budget"
        :bid="bid"
        :objall="objall"
        :aname="aname"
        :tracking_sourceid="tracking_sourceid"
        :zhuanhuaname="zhuanhuaname"
        @setinputvalueaname="$emit('setinputvalueaname',$event)"
        @toufangset="$emit('toufangset',$event)"
        @bendistrategyopt="$emit('bendistrategyopt',$event)"
        @budgetext="$emit('budgetext',$event)"
        @offertext="$emit('offertext',$event)"
        @previousStep="$emit('previousStep')"
        @setLaunchTime="$emit('setLaunchTime',$event)"
        @setLaunchtimeall="$emit('setLaunchtimeall',$event)"
        @setTargetedPopulation="$emit('setTargetedPopulation',$event)"
        @setBudgetExpenditure="$emit('setBudgetExpenditure',$event)"
        @nextStep="$emit('nextStep')"
        @setinputvalue="$emit('setinputvalue',$event)"
        @setLaunchoose="$emit('setLaunchoose',$event)"
        @setLaunchooseone="$emit('setLaunchooseone',$event)"
        @Targetedpopulation="$emit('Targetedpopulation',$event)"
        @dataidsr="$emit('dataidsr',$event)"
        @dataidsrempty="$emit('dataidsrempty',$event)"
        @dataname="$emit('dataname',$event)"
      />
    </div>
  </div>
</template>

<script>
import StandardCreation from './standardCreation.vue'
export default {
  components: {
    StandardCreation
  },
  props: {
    currentIfon: {},
    currentLaunchPlan: {},
    campaign_id: {},
    radioone: {},
    radiotwo: {},
    campaign: {},
    strategy_opt: {},
    bid_strategy: {},
    ad_target: {},
    budget: {},
    bid: {},
    objall: {},
    aname: {},
    tracking_sourceid: {},
    zhuanhuaname: {}
  },
  data() {
    return {
      val: ''
    }
  },
  created() {
    console.log(this.currentIfon, '==========', this.tracking_sourceid)
    // this.advs()
  },
  methods: {
    open() {
      console.log('打开')
    }
  }
}
</script>

<style scoped lang="less">
.advertisement {
  width: 100%;
  .advertisement_top {
    width: 100%;
    height: 200px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    .top_titleArea {
      height: 120px;
      border-bottom: 1px solid #ccc;
      padding: 0px 20px;
      padding-top: 30px;
      .title {
        font-weight: bold;
      }
      .titleArea_option {
        display: flex;
        margin-top: 35px;
        .option_item {
          margin-right: 20px;
          cursor: pointer;
          position: relative;
          &.active {
            color: #07c160;
            font-weight: bold;
            &::before {
              content: '';
              position: absolute;
              width: 100%;
              height: 2px;
              background-color: #07c160;
              top: 204%;
            }
          }
        }
      }
    }

    .top_ifon {
      padding: 0px 20px;
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .ifon_left {
        .text {
        }
      }
      .ifon_right {
        .right_button {
          outline: none;
          cursor: pointer;
          border: none;
          background-color: transparent;
          padding: 8px;
          border-radius: 3px;
          transition: background-color 0.5s;
          color: #07c160;
          &:hover {
            background-color: rgba(115, 223, 137, 0.2);
          }
        }
      }
    }
  }
}
</style>
